import { render, staticRenderFns } from "./ProcessRegistration.vue?vue&type=template&id=3771d8ec&"
import script from "./ProcessRegistration.vue?vue&type=script&lang=js&"
export * from "./ProcessRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports